import type { ResponseType } from '@/types/common';
import type { IssueProject, IssueTemplateFieldConfig, IssueType } from '@/types/issue';
import httpUtil from '@/utils/http';

const request = httpUtil.accurate.request;
const prefix = 'v1';

export const issueProjectApi = {
  /**
   * @description 获取所有项目列表
   */
  getAllProjects(params?: { issueType: number }): ResponseType<IssueProject[]> {
    return request({
      url: prefix + `/allProjects`,
      method: 'GET',
      params,
    });
  },

  /**
   * @description 获取指定项目下的所有问题类型
   */
  getIssueTypeByProject(project: number): ResponseType<IssueType[]> {
    return request({
      url: prefix + `/project/${project}/issueType`,
      method: 'GET',
    });
  },

  /**
   * @description 获取项目下的表单模板
   */
  getProjectTemplate(project: number, issueType: number): ResponseType<IssueTemplateFieldConfig[]> {
    return request({
      url: prefix + `/project/${project}/template`,
      method: 'GET',
      params: { issueType },
    });
  },
};
